/* unplugin-vue-components disabled */import script from "./ParamEditModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./ParamEditModal.vue?vue&type=script&lang=ts&setup=true"

import "./ParamEditModal.vue?vue&type=style&index=0&id=2f0b87e4&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f0b87e4"]])

export default __exports__